
import { defineComponent } from 'vue'
import { Params } from '@/data/types'
import Repos from '@/components/Data/Repos.vue'
import { RouteLocationNormalizedLoaded } from 'vue-router'

export default defineComponent({
  components: {
    Repos,
  },
  data(this: { $route: RouteLocationNormalizedLoaded }) {
    return {
      params: {
        username: this.$route.query.username,
        organizations: this.$route.query.orgs,
        repositories: this.$route.query.repos,
        chart: this.$route.query.chart,
      } as Params,
    }
  },
})
